module.exports = __webpack_public_path__ + "static/media/stage-edge.d26c67da.png";